export const TABLES_FIREBASE = {
	transactions: "transactions",
	customer: "customer",
	contract: "contract",
	truckmove: "truckmove",
	ordemCarrega: "ordemCarrega",
	caldaAvulsa: "calda_avulsa"
};
